import { Core } from "@/core/Core";

export default {

  /* Custom Items */

  async getCustomItems(context, {inventoryId}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/custom_items`, {admin: true});
    } catch (e) {
      return null;
    }
  },

  async getCustomItem(context, {inventoryId, itemId}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/custom_items/${itemId}`);
    } catch (e) {
      return null;
    }
  },

  async saveCustomItem(context, {inventoryId, itemId, data}) {
    try {
      return await Core.request("PUT", "/api/inventory/" + inventoryId + "/custom_items/" + itemId, data);
    } catch (e) {
      return null;
    }
  },

  async createCustomItem(context, {inventoryId, data}) {
    try {
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/custom_items", data);
    } catch (e) {
      return null;
    }
  },
}
